import type { Team } from '@/types/api';
import { cn } from '@/utils/cn';

const STYLES = {
  display: {
    crest: 'size-[18vh]',
    flag: 'text-[12vh]',
    name: 'text-[15vh] font-bold',
    score: 'text-[20vh] font-medium',
    gap: 'px-[3vh]',
  },
  overlay: {
    crest: 'size-12',
    flag: 'text-3xl',
    name: 'text-lg font-semibold',
    score: 'text-5xl font-bold',
    gap: 'px-2',
  },
  control: {
    crest: 'size-12',
    flag: 'text-2xl',
    name: 'text-2xl font-medium',
    score: 'text-4xl font-medium',
    gap: 'px-4',
  },
} as const;

export const ScoreBlock = ({
  team,
  score,
  variant,
  reverse = false,
}: {
  team: Team;
  score: number;
  variant: keyof typeof STYLES;
  reverse?: boolean;
}) => {
  const style = STYLES[variant];

  return (
    <div
      className={cn(
        'flex items-center leading-none',
        reverse ? 'flex-row-reverse' : 'flex-row',
      )}
    >
      {team.team_image_url ? (
        <img
          className={style.crest}
          src={team.team_image_url}
          alt={team.name}
        />
      ) : (
        <span
          role="img"
          aria-label={team.name}
          className={cn(
            'fi',
            style.flag,
            team.country_code && `fi-${team.country_code}`,
          )}
        />
      )}
      <div className={cn('uppercase text-slate-700', style.name, style.gap)}>
        {team.scoreboard_name}
      </div>
      <div className={cn('uppercase', style.score)}>{score}</div>
    </div>
  );
};
